import React, { Component } from 'react';
import {
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from '@mui/material';
import { styled } from '@mui/material/styles';

const filterSelectStyle = {
  width: '25%',
  marginLeft: '0.5em',
  marginRight: '0.5em',
};

const StyledSelect = styled((props: Parameters<typeof Select>[0]) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Select classes={{ outlined: 'outlined' }} {...props} />
))`
  & .outlined {
    padding: '10.5px 14px 10.5px 14px';
  }
`;

export type MenuOptionsType = {
  displayValue: React.ReactNode;
  value: string;
}

type Props = {
  options: MenuOptionsType[];
  onChange: (value: string) => void;
  id?: string;
  label: React.ReactNode;
  value?: string;
  hide?: boolean;
  multiple?: boolean;
}

type State = {
  value: string;
}
class FilterSelect extends Component<Props, State> {
  static props = {
    hide: false,
  };

  render(): React.ReactNode {
    const {
      options, onChange, id, label, hide, multiple,
    } = this.props;

    if (hide) {
      return null;
    }
    const { value: propValue } = this.props;
    return (
      <FormControl style={filterSelectStyle}>
        <InputLabel>{label}</InputLabel>
        <StyledSelect
          id={id}
          label={label}
          value={propValue}
          onChange={(event: any) => {
            const { value } = event.target;
            onChange(value as string);
          }}
          multiple={multiple}
          variant="standard"
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.displayValue}
            </MenuItem>
          ))}
        </StyledSelect>
      </FormControl>
    );
  }
}

export default FilterSelect;
